import { useBreakpoint } from "@/utils/hooks/useBreakpoint";

/** Mobile + tablet card/list layout; desktop uses table layout. */
export function useCompactListLayout() {
    const { isDesktop } = useBreakpoint();
    return !isDesktop;
}
